// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ICalculationAccountAmountResponseDto
 */
export interface ICalculationAccountAmountResponseDto {
    /**
     * 
     * @type {number}
     * @memberof ICalculationAccountAmountResponseDto
     */
    account_id?: number;
    /**
     * 
     * @type {number}
     * @memberof ICalculationAccountAmountResponseDto
     */
    amount?: number;
}

/**
 * Check if a given object implements the ICalculationAccountAmountResponseDto interface.
 */
export function instanceOfICalculationAccountAmountResponseDto(value: object): value is ICalculationAccountAmountResponseDto {
    return true;
}

export function ICalculationAccountAmountResponseDtoFromJSON(json: any): ICalculationAccountAmountResponseDto {
    return ICalculationAccountAmountResponseDtoFromJSONTyped(json, false);
}

export function ICalculationAccountAmountResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ICalculationAccountAmountResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'account_id': json['account_id'] == null ? undefined : json['account_id'],
        'amount': json['amount'] == null ? undefined : json['amount'],
    };
}

export function ICalculationAccountAmountResponseDtoToJSON(json: any): ICalculationAccountAmountResponseDto {
    return ICalculationAccountAmountResponseDtoToJSONTyped(json, false);
}

export function ICalculationAccountAmountResponseDtoToJSONTyped(value?: ICalculationAccountAmountResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'account_id': value['account_id'],
        'amount': value['amount'],
    };
}

